// extracted by mini-css-extract-plugin
export var cardTitle = "_cg-1";
export var commentBubble = "_cg-e";
export var commentForm = "_cg-a";
export var commentInput = "_cg-b";
export var commentLabel = "_cg-d";
export var commentPrompt = "_cg-9";
export var csatCard = "_cg-0";
export var feedbackSection = "_cg-7";
export var starDisabled = "_cg-6";
export var starEmpty = "_cg-5";
export var starFilled = "_cg-4";
export var starWrapper = "_cg-3";
export var starsContainer = "_cg-2";
export var submittedComment = "_cg-c";
export var thankYouText = "_cg-8";